import { render, staticRenderFns } from "./ShortDescriptions.vue?vue&type=template&id=e6ddb5ea&scoped=true&"
import script from "./ShortDescriptions.vue?vue&type=script&lang=js&"
export * from "./ShortDescriptions.vue?vue&type=script&lang=js&"
import style0 from "./ShortDescriptions.vue?vue&type=style&index=0&id=e6ddb5ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6ddb5ea",
  null
  
)

export default component.exports